import axios from 'axios';
import { backend_url } from '@/functions/utils';

const backendApi = axios.create({
  baseURL: backend_url,
});

backendApi.interceptors.response.use(
  (response) => response,
  (error) => {
    let logMessage = '[Axios] Erreur backend :';
    let logDetails = {};

    if (error.response) {
      logMessage += ` [${error.response.status}]`;
      logDetails = {
        status: error.response.status,
        data: error.response.data,
        url: error.config?.baseURL + error.config?.url,
        method: error.config?.method,
      };
    } else {
      logMessage += ' Erreur réseau ou de configuration';
      logDetails = {
        message: error.message,
        url: error.config?.baseURL + error.config?.url,
      };
    }

    console.error(logMessage, logDetails);

    return Promise.reject(error);
  }
);

export default backendApi;
